<script>
export default {
  name: "ArticleProverbs",
  props: {
    proverbs: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <div class="article-content__body-container">
    <div class="article-content__politiken-box">
      <div
        class="article-content__politiken-box-header article-content__politiken-box-header--primary"
      >
        Ordsprog:
      </div>
      <div class="article-content__politiken-box-content">
        <div
          v-for="(proverb, proverbIndex) in proverbs"
          :key="proverbIndex"
          :class="{ 'mb-3': proverbs.length > proverbIndex + 1 }"
        >
          <span
            class="article-content__politiken-box-content-text article-content__politiken-box-content-text--prominent"
            >{{ proverb.proverb }}</span
          >
          <span
            v-if="proverb.definition"
            class="article-content__politiken-box-content-text article-content__politiken-box-content-text--chained"
            >{{ proverb.definition }}</span
          >
          <span
            v-if="proverb.example"
            class="article-content__politiken-box-content-text article-content__politiken-box-content-text--chained article-content__politiken-box-content-text--light article-content__politiken-box-content-text--italic"
            >{{ proverb.example }}</span
          >
        </div>
      </div>
    </div>
    <div class="article-content__spacer"></div>
  </div>
</template>
